// src/components/GenericDialogueFooter/GenericDialogueFooter.tsx

import Button from 'src/components/Button';
import React from 'react';

const SuccessFooter = ({
  onImportAnother,
  onDone,
}: {
  onImportAnother: () => void;
  onDone: () => void;
}) => (
  <>
    <Button
      color="semantic"
      size="small"
      label="Import Another File"
      onClick={onImportAnother}
    />
    <Button color="teal" size="small" label="Done" onClick={onDone} />
  </>
);

const ImportingFooter = () => (
  <Button color="semantic" size="small" label="Cancel" disabled={true} />
);

interface DefaultFooterProps {
  file: File | null;
  isValidCsv: boolean;
  isImportError: boolean;
  isImportEnabled: boolean;
  importButtonLabel: string;
  onCancel: () => void;
  onReset: () => void;
  onImport: () => void;
}

const DefaultFooter = ({
  file,
  isValidCsv,
  isImportError,
  isImportEnabled,
  importButtonLabel,
  onCancel,
  onReset,
  onImport,
}: DefaultFooterProps) => {
  const showTryAgain: boolean = !!(file && (!isValidCsv || isImportError));

  return (
    <>
      <Button
        color="semantic"
        size="small"
        label={showTryAgain ? '← Try Again' : 'Cancel'}
        onClick={showTryAgain ? onReset : onCancel}
        style={{ marginRight: '1rem' }}
      />
      <Button
        color="teal"
        size="small"
        label={isImportError ? 'Retry Import' : importButtonLabel}
        onClick={onImport}
        disabled={!isImportEnabled}
      />
    </>
  );
};

interface DialogueFooterProps {
  isSuccess: boolean;
  isImporting: boolean;
  file: File | null;
  isValidCsv: boolean;
  isImportError: boolean;
  isImportEnabled: boolean;
  importButtonLabel?: string;
  reset: () => void;
  handleImportComplete: () => void;
  handleClose: () => void;
  runImport: () => void;
}

const DialogueFooter = ({
  isSuccess,
  isImporting,
  file,
  isValidCsv,
  isImportError,
  isImportEnabled,
  importButtonLabel = 'Import',
  reset,
  handleImportComplete,
  handleClose,
  runImport,
}: DialogueFooterProps) => {
  if (isSuccess) {
    return (
      <SuccessFooter onImportAnother={reset} onDone={handleImportComplete} />
    );
  }

  if (isImporting) {
    return <ImportingFooter />;
  }

  return (
    <DefaultFooter
      file={file}
      isValidCsv={isValidCsv}
      isImportError={isImportError}
      isImportEnabled={isImportEnabled}
      importButtonLabel={importButtonLabel}
      onCancel={handleClose}
      onReset={reset}
      onImport={runImport}
    />
  );
};

export default DialogueFooter;